/*
 *
 * taskAPI.js
 *
 */

import Axios from "axios";
import moment from "moment";

let suggestionsCancelToken;
let rowCommentCancelToken;
let rowContextCancelToken;


const taskAPI = {
    fetchByID: async data => await Axios.get(`${window.API_URL}/task/get.php?taskID=${data.taskID}`),
    fetchAll: async () => await Axios.get(`${window.API_URL}/task/get.php`),
    create: async data => await Axios.post(`${window.API_URL}/task/createNew.php`, data.formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }),
    delete: async data => await Axios.post(`${window.API_URL}/task/delete.php`, {
        taskIDs: data.taskIDs
    }),
    assignTranslator: async data => await Axios.post(`${window.API_URL}/task/assign.php`, {
        taskIDs: data.taskIDs,
        userID: data.userID,
        type: "translator"
    }),
    assignEditor: async data => await Axios.post(`${window.API_URL}/task/assign.php`, {
        taskIDs: data.taskIDs,
        userID: data.userID,
        type: "editor"
    }),
    split: async data => await Axios.post(`${window.API_URL}/task/split.php`, {
        taskID: data.taskID,
        splitBy: data.splitBy,
        splitMethod: data.splitMethod,
        splitAmount: data.splitAmount
    }),
    fetchByProject: async data => await Axios.get(`${window.API_URL}/task/get.php?projectID=${data.projectID}`),
    save: async (taskID, rowIDs, targets, completeds) => await Axios.post(`${window.API_URL}/task/save.php`, {
        taskID,
        ids: rowIDs,
        targets,
        completeds
    }),
    fetchSuggestions: async data => {
        if(suggestionsCancelToken) suggestionsCancelToken.cancel();

        suggestionsCancelToken = Axios.CancelToken.source();

        return await Axios.get(`${window.API_URL}/task/suggestions.php?rowID=${data.rowID}`, {cancelToken: suggestionsCancelToken.token});
    },
    setDue: async data => await Axios.post(`${window.API_URL}/task/setDue.php`, {
        taskIDs: data.taskIDs,
        date: moment(data.date).format("YYYY-MM-DD"),
        type: data.type
    }),
    setStatus: async data => await Axios.post(`${window.API_URL}/task/setStatus.php`, {
        taskIDs: data.taskIDs,
        status: data.status
    }),
    finish: async data => await Axios.post(`${window.API_URL}/task/finish.php`, {
        taskID: data.taskID
    }),
    preTranslate: async data => await Axios.post(`${window.API_URL}/task/preTranslate.php`, {
        taskIDs: data.taskIDs,
        memoryMatchThreshold: data.memoryMatchThreshold
    }),
    saveRowComment: async data => await Axios.post(`${window.API_URL}/task/saveRowComment.php`, {
        comment: data.comment,
        rowID: data.rowID
    }),
    fetchRowComment: async data => {
        if(rowCommentCancelToken) rowCommentCancelToken.cancel();
        rowCommentCancelToken = Axios.CancelToken.source();
        return await Axios.get(`${window.API_URL}/task/getRowComment.php?rowID=${data.rowID}`, {cancelToken: rowCommentCancelToken.token});
    },
    fetchRowContextNotes: async data => {
        if(rowContextCancelToken) rowContextCancelToken.cancel();
        rowContextCancelToken = Axios.CancelToken.source();
        return await Axios.get(`${window.API_URL}/task/getRowContextNotes.php?rowID=${data.rowID}`, {cancelToken: rowContextCancelToken.token});
    },
    splitGender: async data => await Axios.post(`${window.API_URL}/task/splitRowGender.php`, {
        rowID: data.rowID
    }),
    deleteTranslations: async data => await Axios.post(`${window.API_URL}/task/deleteTranslations.php`, {
        taskIDs: data.taskIDs    })
};

export default taskAPI;